import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Head() {
  const navRef = useRef(null);
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <nav ref={navRef} className={`navbar navbar-expand-lg${scrolled ? ' nav-scroll' : ''}`}>
      <div className="container">

        {/* Logo */}
        <Link to="/" className="navbar-brand p-0">
          <img src={`${process.env.PUBLIC_URL}/img/logo.png`} alt="Black Rock Hotel" style={{ height: '60px' }} />
        </Link>

        {/* Mobile toggle */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon">
            <i className={`fa-light ${menuOpen ? 'fa-xmark' : 'fa-bars'}`}></i>
          </span>
        </button>

        {/* Menu */}
        <div className={`collapse navbar-collapse${menuOpen ? ' show' : ''}`} id="navbar">
          <ul className="navbar-nav mx-auto">
            <li className="nav-item">
              <Link className={`nav-link ${isActive('/')}`} to="/">Home</Link>
            </li>
            <li className="nav-item">
              <Link className={`nav-link ${isActive('/about')}`} to="/about">About Us</Link>
            </li>
            <li className="nav-item">
              <Link className={`nav-link ${isActive('/rooms')}`} to="/rooms">Rooms</Link>
            </li>
            <li className="nav-item dropdown">
              <Link
                className={`nav-link dropdown-toggle ${isActive('/spa') || isActive('/treatment') ? 'active' : ''}`}
                to="/spa"
                role="button"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                aria-expanded="false"
              >
                Destination Spa <i className="fa-light fa-angle-down"></i>
              </Link>
              <ul className="dropdown-menu">
                <li><Link to="/spa" className="dropdown-item"><span>Spa & Wellness</span></Link></li>
                <li><Link to="/treatment" className="dropdown-item"><span>Recovery & Treatment</span></Link></li>
              </ul>
            </li>
            <li className="nav-item">
              <Link className={`nav-link ${isActive('/experiences')}`} to="/experiences">Experiences</Link>
            </li>
            <li className="nav-item">
              <Link className={`nav-link ${isActive('/contact')}`} to="/contact">Contact</Link>
            </li>
          </ul>

          {/* Right side */}
          <div className="navbar-right d-flex align-items-center">
            <div className="phonex">
              <a href="tel:+97675100111">
                <i className="fa-solid fa-phone"></i> +976 75100111
              </a>
            </div>
          </div>
        </div>

      </div>
    </nav>
  );
}

export default Head;
